import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { Brand } from "../brand/Brand";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useSelector, shallowEqual } from "react-redux";
import { roles, getDatabaseNamePath } from "../../../../app/config/config";
import { useIsMobile } from "../../../../app/useIsMobile";
import { toAbsoluteUrl } from "../../../_helpers";
import SVG from "react-inlinesvg";

export function Aside() {
  const uiService = useHtmlClassService();

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  
  const isMobile = useIsMobile();

  const layoutProps = useMemo(() => {
    return {
      disableScroll: objectPath.get(uiService.config, "aside.menu.dropdown") === "true" || false,
      asideSelfMinimizeToggle: objectPath.get(uiService.config, "aside.self.minimize.toggle"),
      asideClassesFromConfig: uiService.getClasses("aside", true),
      disableAsideSelfDisplay: objectPath.get(uiService.config, "aside.self.display") === false,
      headerLogo: uiService.getLogo(),
      asideStyle: `aside-${getDatabaseNamePath()}`,
      // (role === roles.agenteValderma)
      //   ? "aside-valderma"
      //   : role === roles.agenteRoypet
      //     ? "aside-roypet"
      //     : role === roles.agenteRoydermal
      //       ? "aside-roydermal"
      //       : "aside-global"
    };
  }, [uiService, role]);

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside ${layoutProps.asideStyle} aside-left  ${layoutProps.asideClassesFromConfig} d-flex flex-column flex-row-auto`}
      >
        {layoutProps.asideSelfMinimizeToggle && (
          <>
            {/* begin::Toggle */}
            {!isMobile && (
            <div className="text-right m-4">
              <button className="brand-toggle btn p-0 burger-icon burger-icon-left" id="kt_aside_toggle">
                <span></span>
              </button>
              {
              /* <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
            <span className="svg-icon svg-icon-xl">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-left.svg")} />
            </span>
          </button> */
          }
            </div>
            )}
            {/* end::Toolbar */}
          </>
        )}
        <Brand />

        {/* begin::Aside Menu */}
        <div id="kt_aside_menu_wrapper" className="aside-menu-wrapper flex-column-fluid">
          {layoutProps.disableAsideSelfDisplay && (
            <>
              {/* begin::Header Logo */}
              <div className="header-logo">
                <Link to="">
                  <img alt="logo" src={layoutProps.headerLogo} />
                </Link>
              </div>
              {/* end::Header Logo */}
            </>
          )}
          <AsideMenu disableScroll={layoutProps.disableScroll} />
        </div>
        {/* end::Aside Menu */}
      </div>
      {/* end::Aside */}
    </>
  );
}
